export {TranslationNamespaces} from './types'
export type {TranslationKeys, TranslationObjectKeys, TranslationArrayKeys,
    TranslationOptions, TranslationObject, NestedTranslation, RelativeTimeFormatUnit,
    PlayerDisplayName, PlayerDisplayNameEnd, PlayerDisplayNameStart} from './types'

export {getNestedTranslation} from './nested'

export {checkValueIsTranslationObject} from './validation'

export {loopNestedStrings} from './utils'

export * from './context'

import * as englishStrings from './locales/en/strings.json'

export default englishStrings

export * from './translations'
